"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationTemplates = void 0;
var NotificationTemplates;
(function (NotificationTemplates) {
    NotificationTemplates["CCP_ADC_BANK_TRANSFER_REFUND"] = "COM_ccp_internal_ADC_refund_bank_transfer_email";
    NotificationTemplates["CCP_ADC_INTERNAL_REFUND_ON_ACCOUNT"] = "COM_ccp_internal_ADC_refund_on_account_email";
})(NotificationTemplates = exports.NotificationTemplates || (exports.NotificationTemplates = {}));
